/* eslint-disable */
// This file was automatically generated and should not be edited.

import * as Types from '../../../apollo/__generated__/global-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FreshProductsQueryVariables = Types.Exact<{
  pageRequestInput?: Types.InputMaybe<Types.NumberedPageRequestInput>;
  sort?: Types.InputMaybe<Types.ReviewSort>;
  filter?: Types.InputMaybe<Types.ReviewFiltersInput>;
}>;


export type FreshProductsQuery = { freshProducts: Array<{ id: string, foodFlavor?: string | null, ingredients?: string | null, caloricContent?: string | null, itemPartNumbers: Array<string>, partNumber: string, productFormattedDescriptions: { frequentlyAskedQuestions?: string | null, guaranteedAnalysis?: string | null }, reviewsPage?: { hasNextPage?: boolean | null, totalResults?: number | null, results: Array<{ id: string, partNumber: string, title?: string | null, reviewText?: string | null, rating?: number | null, submittedAt?: any | null, submittedBy?: string | null, isIncentivized: boolean }> } | null, reviewStatistics?: { totalReviewCount?: number | null, averageRating?: number | null, partNumber: string } | null }>, promotions: Array<{ promotion: { id: string, shortDescription?: string | null, isFreshItemDiscount: boolean, promotionId: string, facets?: Array<{ name?: string | null, value?: Types.PromotionFacetType | null }> | null } }> };

export type FreshProductFragment = { id: string, foodFlavor?: string | null, ingredients?: string | null, caloricContent?: string | null, itemPartNumbers: Array<string>, partNumber: string, productFormattedDescriptions: { frequentlyAskedQuestions?: string | null, guaranteedAnalysis?: string | null }, reviewsPage?: { hasNextPage?: boolean | null, totalResults?: number | null, results: Array<{ id: string, partNumber: string, title?: string | null, reviewText?: string | null, rating?: number | null, submittedAt?: any | null, submittedBy?: string | null, isIncentivized: boolean }> } | null, reviewStatistics?: { totalReviewCount?: number | null, averageRating?: number | null, partNumber: string } | null };

export type FreshProductReviewFragment = { id: string, partNumber: string, title?: string | null, reviewText?: string | null, rating?: number | null, submittedAt?: any | null, submittedBy?: string | null, isIncentivized: boolean };

export type FreshPromotionFragment = { promotion: { id: string, shortDescription?: string | null, isFreshItemDiscount: boolean, promotionId: string, facets?: Array<{ name?: string | null, value?: Types.PromotionFacetType | null }> | null } };

export const FreshProductReviewFragmentDoc = gql`
    fragment Fresh_ProductReview on Review {
  id
  partNumber
  title
  reviewText
  rating
  submittedAt
  submittedBy
  isIncentivized
}
    `;
export const FreshProductFragmentDoc = gql`
    fragment Fresh_Product on Product {
  id
  foodFlavor
  ingredients
  caloricContent
  itemPartNumbers
  partNumber
  productFormattedDescriptions {
    frequentlyAskedQuestions
    guaranteedAnalysis
  }
  reviewsPage(pageRequestInput: $pageRequestInput, sort: $sort, filter: $filter) {
    hasNextPage
    totalResults
    results {
      ...Fresh_ProductReview
    }
  }
  reviewStatistics {
    totalReviewCount
    averageRating
    partNumber
  }
}
    ${FreshProductReviewFragmentDoc}`;
export const FreshPromotionFragmentDoc = gql`
    fragment Fresh_Promotion on PromotionSearchResult {
  promotion {
    id
    shortDescription
    isFreshItemDiscount
    promotionId
    facets {
      name
      value
    }
  }
}
    `;
export const FreshProductsDocument = gql`
    query Fresh_Products($pageRequestInput: NumberedPageRequestInput, $sort: ReviewSort, $filter: ReviewFiltersInput) {
  freshProducts {
    ...Fresh_Product
  }
  promotions(groups: [FRESH]) {
    ...Fresh_Promotion
  }
}
    ${FreshProductFragmentDoc}
${FreshPromotionFragmentDoc}`;

/**
 * __useFreshProductsQuery__
 *
 * To run a query within a React component, call `useFreshProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFreshProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFreshProductsQuery({
 *   variables: {
 *      pageRequestInput: // value for 'pageRequestInput'
 *      sort: // value for 'sort'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFreshProductsQuery(baseOptions?: Apollo.QueryHookOptions<FreshProductsQuery, FreshProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FreshProductsQuery, FreshProductsQueryVariables>(FreshProductsDocument, options);
      }
export function useFreshProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FreshProductsQuery, FreshProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FreshProductsQuery, FreshProductsQueryVariables>(FreshProductsDocument, options);
        }
export function useFreshProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FreshProductsQuery, FreshProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FreshProductsQuery, FreshProductsQueryVariables>(FreshProductsDocument, options);
        }
export type FreshProductsQueryHookResult = ReturnType<typeof useFreshProductsQuery>;
export type FreshProductsLazyQueryHookResult = ReturnType<typeof useFreshProductsLazyQuery>;
export type FreshProductsSuspenseQueryHookResult = ReturnType<typeof useFreshProductsSuspenseQuery>;
export type FreshProductsQueryResult = Apollo.QueryResult<FreshProductsQuery, FreshProductsQueryVariables>;